module.exports = __webpack_public_path__ + "media/images/favicon-02fcb89bd953d5fbf9292de93c22f2dc.ico";